import Loader from 'components/Loader'
import UnautorizedRoute from 'containers/UnautorizedRoute'
import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import { isLoggedInSelector } from 'store/modules/user/selectors'

import VerificationsDetails from './components/VerificationsDetails'

export default function MyAccountDetails() {
  const loggedIn = useAppSelector(isLoggedInSelector)
  const appInitialized = useAppSelector(isAppInitializedSelector)

  if (!appInitialized) {
    return <Loader />
  }

  if (!loggedIn) {
    return <UnautorizedRoute />
  }

  return <VerificationsDetails />
}
